import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'
import { Typography, StarRating, CircleRating } from '@homeviews/shared-ui'
import { maybePlaceholderImage } from '@homeviews/utils'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {},
    logoWrapper: {
      position: 'relative',
      overflow: 'hidden',
      height: 63,
      width: 130,
      marginRight: 30,
      '& img': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    headerMain: {
      marginRight: 25,
    },
    body: {
      flex: 1,
      paddingTop: theme.spacing(1.375),
    },
    title: {
      marginBottom: 20,
    },
    meta: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: 10,
    },
    metaEl: {
      color: theme.colors.grey450,
      marginRight: theme.spacing(0.9375),
      marginTop: theme.spacing(0.625),
      marginBottom: theme.spacing(0.625),
    },
    metaElNoMargin: {
      marginTop: 0,
    },
    starRatingWrapper: {
      marginTop: 2,
    },
    metaElItemWrapper: {
      fontSize: 14,
      '& span': {
        color: '#434343',
        fontWeight: 500,
        fontSize: 16,
      },
    },
    ratingWrapper: {
      marginRight: 30,
    },
    circles: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '4%',
    },
    circleRating: {
      marginRight: 0,
    },
  }),
)
interface IProps {
  className?: string
  hasDeveloper?: boolean
  no_of_reviews?: number
  name: string
  logoUrl?: string
  developerRating: string
  rating?: string
  rating_overall: number
  rating_facilities: number
  rating_design: number
  rating_location: number
  rating_value: number
  rating_management: number
}

const CompanyStatsCard: FC<IProps> = ({
  className,
  hasDeveloper,
  name,
  logoUrl,
  no_of_reviews,
  developerRating,
  rating,
  rating_overall,
  rating_facilities,
  rating_design,
  rating_location,
  rating_value,
  rating_management,
}) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.header}>
        <div className={classes.headerMain}>
          <Typography variant="h3" className={classes.title}>
            {name}
          </Typography>
          <StarRating value={parseFloat(developerRating)} fontSize={32} />
        </div>

        {hasDeveloper && (
          <div className={classes.logoWrapper}>
            <img src={maybePlaceholderImage(logoUrl)} alt="Company logo" />
          </div>
        )}
      </div>
      <div className={classes.body}>
        <div className={classes.meta}>
          <div className={clsx(classes.ratingWrapper)}>
            <Typography
              className={clsx(classes.metaEl, classes.metaElItemWrapper)}
            >
              <span style={{ marginLeft: '8px' }}>{rating} </span>{' '}
              {`(${no_of_reviews} ${
                no_of_reviews === 1 ? 'review' : 'reviews'
              })`}
            </Typography>
          </div>
        </div>
        <div className={classes.circles}>
          <CircleRating
            className={classes.circleRating}
            title="Overall"
            value={rating_overall}
          />
          <CircleRating
            className={classes.circleRating}
            title="Facilities"
            value={rating_facilities}
          />
          <CircleRating
            className={classes.circleRating}
            title="Design"
            value={rating_design}
          />
          <CircleRating
            className={classes.circleRating}
            title="Location"
            value={rating_location}
          />
          <CircleRating
            className={classes.circleRating}
            title="Value"
            value={rating_value}
          />
          <CircleRating
            className={classes.circleRating}
            title="Management"
            value={rating_management}
          />
        </div>
      </div>
    </div>
  )
}

export default CompanyStatsCard
